import window from './window_wrapper';

export function updateGoogleConsent(adPersonalizationValue) {
  if (window.gtag !== undefined) {
    const googleConsent = adPersonalizationValue ? 'granted' : 'denied';
    window.gtag('consent', 'update', {
      'ad_storage': googleConsent,
      'ad_user_data': googleConsent,
      'ad_personalization': googleConsent,
      'analytics_storage': googleConsent,
    });
  }
}
